"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupAmplitudeMemo = exports.setupAmplitude = exports.productionApiEndpoint = exports.amplitudeOptions = exports.defaultAvoInspectorApiKey = void 0;
const amplitude_js_1 = __importDefault(require("amplitude-js"));
const apiPath = "/my/profile_data/amplitude";
// api key for avo inspector, this is public key that can't be used to read any data, it only reports schema of our events.
exports.defaultAvoInspectorApiKey = "qGemM7Sy8vhPF6H1XQnH";
const getApiData = (fetchFn, logFn) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetchFn(apiPath, {
        credentials: "same-origin",
    });
    if (response.status === 200) {
        return {
            success: true,
            value: yield response.json(),
        };
    }
    else if (response.status === 401) {
        return {
            success: false,
            error: `Failed to fetch Amplitude data from ${apiPath}; Amplitude events will not be tracked, as the user is not logged in.`,
        };
    }
    else {
        logFn(`Failed to fetch Amplitude data from ${apiPath}`, response);
        return {
            success: false,
            error: `could not retrieve amplitude data from ${apiPath}`,
        };
    }
});
exports.amplitudeOptions = {
    includeUtm: true,
    includeReferrer: true,
    unsetParamsReferrerOnNewSession: true,
    transport: "beacon",
    saveParamsReferrerOncePerSession: false,
};
exports.productionApiEndpoint = "amplitude.uw2.analytics.cultureamp.com";
const setupAmplitude = (avoInspectorApiKey, fetchFn, amplitude, logFn) => __awaiter(void 0, void 0, void 0, function* () {
    const apiResult = yield getApiData(fetchFn, logFn);
    if (apiResult.success === false) {
        return apiResult;
    }
    const { apiKey, deviceId, sessionId, environment, userAggregateId, accountAggregateId, } = apiResult.value;
    if (!apiKey || !environment) {
        const error = `
    Property missing from response from ${apiPath}
    Expected: apiKey, environment
    Received: ${Object.keys(apiResult.value).join(", ")}
    `;
        logFn(error);
        return {
            success: false,
            error,
        };
    }
    // In production we run analytics through our own proxy. We don't want to do this in development, as it interferes with the Amplitude chrome extension
    if (environment === "production") {
        exports.amplitudeOptions.apiEndpoint = exports.productionApiEndpoint;
    }
    amplitude.init(apiKey, userAggregateId, exports.amplitudeOptions);
    if (accountAggregateId) {
        amplitude.setGroup("Account", accountAggregateId);
    }
    if (amplitude.isNewSession() && sessionId) {
        amplitude.setSessionId(sessionId);
    }
    if (deviceId) {
        amplitude.setDeviceId(deviceId);
    }
    // set user viewport
    amplitude.setUserProperties({
        "Viewport width": window.innerWidth,
        "Viewport height": window.innerHeight,
    });
    const { AvoInspector } = require("avo-inspector");
    const inspector = new AvoInspector({
        apiKey: avoInspectorApiKey,
        env: environment === "production" ? "prod" : "dev",
        version: "1.0.0",
        appName: undefined,
        suffix: avoInspectorApiKey,
    });
    // configure smaller batch sizes so the reports are sent more aggresively
    // batch size means after how many event types the report is sent
    inspector.setBatchSize(5); // default 30
    // batch flush triggers sending report on next event
    // so for example when you have 1 event in queue it is not sent until 5 events come (batch size) or another event comes after more than 5 seconds (batch flush).
    // if second event doesn't come report is not sent
    inspector.setBatchFlushSeconds(5); // default 30s
    // to keep backward compatibility we asign the inspector to the amplitude instance so every time we use the instance we have attached inspector
    // when we implement avo fully we will replace this library
    Object.defineProperty(amplitude, "inspector", {
        value: inspector,
        configurable: true,
    });
    return { success: true, value: amplitude };
});
exports.setupAmplitude = setupAmplitude;
const setupAmplitudePromise = {};
const setupAmplitudeMemo = (avoInspectorApiKey, fetchFn, amplitude, logFn) => {
    if (typeof window === "undefined") {
        return null;
    }
    const inspectorApiKey = avoInspectorApiKey !== null && avoInspectorApiKey !== void 0 ? avoInspectorApiKey : exports.defaultAvoInspectorApiKey;
    if (!setupAmplitudePromise[inspectorApiKey]) {
        setupAmplitudePromise[inspectorApiKey] = (0, exports.setupAmplitude)(inspectorApiKey, fetchFn !== null && fetchFn !== void 0 ? fetchFn : fetch, amplitude !== null && amplitude !== void 0 ? amplitude : amplitude_js_1.default.getInstance(), 
        // eslint-disable-next-line no-console
        logFn !== null && logFn !== void 0 ? logFn : console.log);
    }
    return setupAmplitudePromise[inspectorApiKey];
};
exports.setupAmplitudeMemo = setupAmplitudeMemo;
exports.default = () => (0, exports.setupAmplitudeMemo)();
//# sourceMappingURL=setupAmplitude.js.map